import { DownloadIcon } from "@cynthai/icons";
import { useCallback } from "react";

import Button from "./Button";
import Dropdown from "./Dropdown";
import { m } from "./paraglide/messages";

export interface DownloadableTableData {
  data: Array<Record<string, string | number | null>>;
  columns: string[];
}

export type DownloadTableFormat = "csv" | "excel" | "json" | "clipboard";

const dropdownItems = [
  { value: "csv", label: m.download_csv_file() },
  { value: "excel", label: m.download_excel_file() },
  { value: "json", label: m.download_json_file() },
  { value: "clipboard", label: m.copy_to_clipboard() },
] as const;

export default function DownloadTableButton({
  extractedData,
  onExport,
  className,
}: {
  readonly extractedData: DownloadableTableData;
  readonly onExport: (
    format: DownloadTableFormat,
    data: DownloadableTableData,
  ) => void;
  readonly className?: string;
}) {
  const handleExport = useCallback(
    (format: DownloadTableFormat) => {
      onExport(format, extractedData);
    },
    [extractedData, onExport],
  );

  return (
    <Dropdown
      items={dropdownItems}
      onAction={handleExport}
      aria-label="Download table"
    >
      <Button
        size="sm"
        color="tertiary"
        variant="ghost-bordered"
        isDisabled={extractedData.data.length === 0}
        className={className}
        icon={DownloadIcon}
      >
        {m.download_table()}
      </Button>
    </Dropdown>
  );
}
